<div class="modal-header">
  <!--ep-task-action-modal-->
  <h4 class="modal-title">File Documents</h4>
  <aurora-icon-button class="close" type="button" (click)="activeModal.dismiss('Cross click')" icon="times" size="large"></aurora-icon-button>
</div>
<div class="modal-body">
  <dataservice-error></dataservice-error>
  <div *ngIf="documents" style="margin: 0px">
    <ep-multi-document-file-edit-panel [documents]="documents"></ep-multi-document-file-edit-panel>
  </div>

  <div *ngFor="let filing of filings$ | async; let row = index">
    <ep-multi-document-filing-edit-panel
      *ngIf="filing.DocLink_ID <= 0"
      [item]="filing"
      [firstRow]="row === 0"
    ></ep-multi-document-filing-edit-panel>
  </div>
</div>
<div class="modal-footer">
  <!--ep-task-action-modal-->
  <aurora-button type="button" (click)="save()" [disabled]="model.inProgress" variant="primary">
    <div *ngIf="!model.inProgress && !model.filingComplete">
      <span>Save</span>
    </div>
    <div *ngIf="model.inProgress && !model.filingComplete">
      <span>{{ documents.length - model.fileNumber }}</span>
    </div>
    <div *ngIf="!model.inProgress && model.filingComplete">
      <span>Done</span>
    </div>
  </aurora-button>
  <!-- <button
    type="button"
    class="btn btn-primary"
    [disabled]="model.taskLinkType == 'NOTASK'"
    (click)="saveAndStartTask()"
  >
    <i
      style="margin-right: 4px"
      [class]="
        'fa fa-fw ' +
        (model.autoOpenTask && (app.dsTaskProcess.status == 'Loading' || app.dsTaskGet.status == 'Loading')
          ? 'fa-ep-loading'
          : 'fa-ep-task-start')
      "
      [class.fa-spin]="
        model.autoOpenTask && (app.dsTaskProcess.status == 'Loading' || app.dsTaskGet.status == 'Loading')
      "
    ></i
    ><span>Save &amp; Start Task</span>
  </button> -->
  <!-- <button type="button" class="btn btn-primary" (click)="saveAndRoute()">Save &amp; Route</button> -->
  <!-- <button type="button" class="btn btn-primary" (click)="saveAndDistribute()">Save &amp; Distribute</button> -->
  <aurora-button type="button" (click)="cancel()" variant="ghost">Cancel</aurora-button>
</div>
